import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { ProgramaRepasseBndes } from 'src/app/model/programas-permitidos.model';
import { NaturezasJuridicasAceitasService } from '../naturezas-juridicas-aceitas.service';
import { NaturezaJuridica } from 'src/app/model/natureza-juridica.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';


@Component({
    selector: 'app-programas-permitidos-por-cestas-pesquisa',
    templateUrl: './naturezas-juridicas-aceitas-pesquisa.component.html',
    styleUrls: ['./naturezas-juridicas-aceitas-pesquisa.component.scss'],
    standalone: false
})
export class NaturezasJuridicasAceitasPesquisaComponent implements OnInit {

  public repasseBndes: NaturezaJuridica[] = [];
  public creditoLivre: NaturezaJuridica[] = [];
  public tranches: Tranche[] = [];
  public ideTranche: number;
  public pesquisadoRepasse: boolean = false;
  public pesquisadoCreditoLivre: boolean = false;
  public permissaoGestorEnvio : boolean = false;
  @ViewChild('botoes') botoesPersonalizados: TemplateRef<any>;
  @ViewChild('body') msgPersonalizada: TemplateRef<any>;

  constructor(private trancheService: TrancheService,
    private permissaoService: PermissaoService,
    private repasseBndesService: NaturezasJuridicasAceitasService,
    private creditoLivreService: NaturezasJuridicasAceitasService,
  ) {

  }

  ngOnInit(): void {
    this.trancheService.getTranches().subscribe(tranches => {
      this.tranches = tranches;
    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.permissaoGestorEnvio = resp && resp[ROLE_GESTOR_ENVIO];
    });
  }

  public buscarTodosRepasses() {
    this.pesquisadoRepasse = false;
    this.repasseBndesService.buscarRepasseBndes(this.ideTranche).subscribe
      ((res: NaturezaJuridica[]) => {
        this.repasseBndes = res;
        this.pesquisadoCreditoLivre = false
        this.pesquisadoRepasse = true;

      })
  }
  public buscarTodosCreditoLivre() {
    this.pesquisadoRepasse = false;
    this.creditoLivreService.buscarCreditoLivre(this.ideTranche).subscribe
      ((res: NaturezaJuridica[]) => {
        this.creditoLivre = res;
        this.pesquisadoRepasse = false;
        this.pesquisadoCreditoLivre = true;
      })
  }

  public limpar() {
    this.ideTranche = null;
    this.pesquisadoRepasse = false;
    this.pesquisadoCreditoLivre = false;
  }

}
